import { useIntl } from 'react-intl'

import { AlertCircle } from './icons'

/**
 * Follows a tab's or section's label when a field in it is in error, so a hidden section's errors
 * can be found (WCAG 3.3.1). Assistive technology hears it from {@link ErrorsDescription}.
 */
export function ErrorMark() {
  return <AlertCircle size={16} className="ml-1.5 inline-block shrink-0 align-middle text-error-text" />
}

/** The words a tab holding errors is described by, through `aria-describedby`; not shown. */
export function ErrorsDescription(props: { readonly id: string }) {
  const intl = useIntl()
  return (
    <span id={props.id} hidden>
      {intl.formatMessage({ id: 'ui.tabs.hasErrors' })}
    </span>
  )
}
